import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  FormText
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'
import ReactSelect from "../../../components/Form/Select/Select"
import Permissoes from "./permissoes"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import NumberFormat from 'react-number-format'
import ListaLojas from "./lojas"
import ListaRelatorios from "./relatorios"
import { cpf } from 'cpf-cnpj-validator'

const formSwal = withReactContent(Swal)

const FormUsuario = ({ fechaModal, usuario_id, setUsuario_id}) => {

  const inicialForm = {
    usuario_id:     '',
    usuario:        '',
    cpf:            '',
    email:          '',
    perfil_id:      '',
    ativo:          'S',
    senha:          '',
    confirma_senha: '',
    perfilSelect:   '',
    lojas:          [],
    relatorios:     []
  }

  const [form, onChange, setForm, onChangeSelect, onChangeDate, onChangeCustom, onChangeArray] = useForm(inicialForm)
  const [loading, setLoading]               = useState(true)
  const [activeTab, setActiveTab]           = useState('1')
  const [listaPerfil, setListaPerfil]       = useState([])
  const [listaPermissao, setListaPermissao] = useState([])
  const [validacao, setValidacao]           = useState('')
  const [relatoriosSelecionados, setRelatoriosSelecionados] = useState([]);

  //lista dos perfis
  const listaPerfis = () => {
    let perfis = []
    try {
      const retorno = rest.get(rotas.perfil)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            perfis[i] = { "id"    : ret.lista[i].perfil_id, "title" : ret.lista[i].nome_perfil }
          }
          setListaPerfil(perfis)
        }
      })
    } catch (error) {
      console.log(error);
    }
  }

  const editUsuario = (usuario_id) => {
    const retorno = rest.get(rotas.usuarios+'/'+usuario_id)
    retorno.then(ret => {
      if (ret.success && ret.success == 'S') {
        ret.lista[0].perfilSelect   = {"id":ret.lista[0].perfil_id, "title":ret.lista[0].nome_perfil}
        ret.lista[0].senha          = ''
        ret.lista[0].confirma_senha = ''
        ret.lista[0].lojas          = ret.lojas

        setForm(ret.lista[0])
      }
      setLoading(false)
    })
  }

  //Listas das permissões do perfil selecionado
  const listaPermissoes = (perfil_id) => {
    try{
      const retorno = rest.get(rotas.perfil+perfil_id.id)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != '') {
          setListaPermissao(ret.lista)
        }
      })
    }catch(err){
      return (false)
    }
  }

  const handleRelatoriosChange = (relatorios) => {
    setRelatoriosSelecionados(relatorios);
  };

  useEffect(() => {
    listaPerfis()
    if(usuario_id != ''){
      editUsuario(usuario_id)
    }else{
      setForm(inicialForm)
      setLoading(false)
    }
  },[])

  useEffect(() => {
    if (form.perfilSelect) {
      listaPermissoes(form.perfilSelect)
    }
  },[form.perfilSelect])

  let compare = (string1, string2) => {
    if (string1 !== string2) {
      return true;
    }
    return false;
  };

  let verifyLength = (value, length) => {
    if ((value.length > 0 && (value.length < length))) {
      return true;
    }
    return false;
  };

  const handleSubmit = (evt) => {
    evt.preventDefault()

    form.relatorios = relatoriosSelecionados
      .flatMap((item) =>
        item.relatorios
          .filter((relatorio) => !relatorio.status) // Filtra apenas os com `status: false`
          .map((relatorio) => relatorio.relatorio_id)
          // .map(({ relatorio_id, status }) => ({ relatorio_id, status }))
      );

    console.log("Relatórios com status false:", form.relatorios);

    if (compare(form.senha, form.confirma_senha)) {
      setValidacao('has-danger')
      return false

    }else if ((verifyLength(form.senha, 4)) && (verifyLength(form.confirma_senha, 4))) {
      setValidacao('has-danger')
      return false

    }else if((form.perfil_id === 0)||(form.perfil_id === undefined)){
      Swal.fire(
        'Atenção',
        'Informe as permissões do usuário',
        'warning'
      );

      setValidacao('permissoes');
      setActiveTab('2');
      return false;
    }

    setValidacao('has-success')

    formSwal.queue([{
      title:                'Deseja salvar ?',
      confirmButtonText:    'Salvar',
      showCancelButton:     true,
      text:                 'Essas informações serão salvas no banco',
      showLoaderOnConfirm:  true,
      cancelButtonColor:    '#d33',
      preConfirm: () => {

        const url = rotas.usuarios+'gravar.php'

        if(usuario_id !== ''){
          return rest.post(url, form)
            .then(ret => {
              if (ret.success && ret.success == 'S') {
                editUsuario(usuario_id)
                formSwal.fire('Salvo!', ret.msg, 'success')
              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })

        }else{
          return rest.put(url, form)
            .then(ret => {
              if (ret.success && ret.success == 'S') {
                setUsuario_id(ret.usuario_id)
                editUsuario(ret.usuario_id)
                formSwal.fire('Salvo!',ret.msg,'success')

              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <>
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Nav pills className="nav-pills-default justify-content-center mb-3">
            <NavItem>
              <NavLink
                className = {activeTab == '1' ? 'active' : ''}
                onClick   = {() => setActiveTab('1')}
              >
                Dados do Usuário
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab == '2' ? 'active' : ''}
                onClick   = {() => setActiveTab('2')}
              >
                Permissões
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab == '3' ? 'active' : ''}
                onClick   = {() => setActiveTab('3')}
              >
                Lojas
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab == '4' ? 'active' : ''}
                onClick   = {() => setActiveTab('4')}
              >
                Relatórios
              </NavLink>
            </NavItem>
          </Nav>

          <hr />

          {/* DADOS DO USÚARIO */}
          <Form onSubmit={handleSubmit} autoComplete="off">
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">

              <Row>
                <Col md='2'>
                  <FormGroup>
                    <Label for="usuario_id">Código</Label>
                    <Input
                      disabled
                      id        = "usuario_id"
                      name      = "usuario_id"
                      style     = {{background: '#F9F9F9'}}
                      value     = {form.usuario_id}
                      onChange  = {onChange('usuario')}
                    />
                  </FormGroup>
                </Col>

                <Col md='10'>
                  <FormGroup>
                    <Label for="usuario">Nome</Label>
                    <Input
                      required
                      id        = "usuario"
                      name      = "usuario"
                      value     = {form.usuario}
                      onChange  = {onChange('usuario')}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md='3'>
                  <FormGroup>
                    <Label for="cpf">CPF</Label>
                    <NumberFormat
                      required
                      id            = "cpf"
                      name          = "cpf"
                      type          = "text"
                      mask          = "_"
                      format        = "###.###.###-##"
                      value         = {form.cpf}
                      onChange      = {onChange('cpf')}
                      className     = {cpf.isValid(form.cpf) ? "form-control" : "form-control number-format-invalid"}
                      autoComplete  = "new-password"
                    />
                  </FormGroup>
                </Col>

                <Col md='9'>
                  <FormGroup>
                    <Label for="email">E-mail</Label>
                    <Input
                      required
                      id            = "email"
                      name          = "email"
                      value         = {form.email}
                      onChange      = {onChange('email')}
                      autoComplete  = "new-password"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row className="card-2">
                <Col md='4'>
                <span className="tag-card">Autenticação do usuário</span>
                  <FormGroup check inline className="mb-0 mt-4">
                    <Label check>
                      <Input
                        id        = "ativo"
                        name      = "ativo"
                        type      = "checkbox"
                        checked   = {form.ativo=='S' ? true : false}
                        onChange  = {onChange('ativo')}
                      />
                      <span className="form-check-sign" />Usuário Ativo
                    </Label>
                  </FormGroup>{" "}
                </Col>

                <Col md='4'>
                  <FormGroup className={validacao}>
                    <Label for="senha">Senha</Label>
                    <Input
                      id            = "senha"
                      name          = "senha"
                      type          = "password"
                      range         = "[1,8]"
                      placeholder   = "*****"
                      value         = {form.senha}
                      onChange      = {onChange('senha')}
                      autoComplete  = "new-password"
                    />
                  </FormGroup>
                </Col>

                <Col md='4'>
                  <FormGroup className={validacao}>
                    <Label for="confirma_senha">Redigite senha</Label>
                    <Input
                      id          = "confirma_senha"
                      name        = "confirma_senha"
                      type        = "password"
                      placeholder = "*****"
                      value       = {form.confirma_senha}
                      onChange    = {onChange('confirma_senha')}
                    />
                  </FormGroup>
                </Col>
              </Row>

            </TabPane>
          </TabContent>

          {/* PERMISSÕES */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="2">
              <Row className="justify-content-md-center">
                <Col md='6' className="text-center">
                  <h5>PERFIL DE USUÁRIO</h5>
                  <FormGroup>
                    <ReactSelect
                      name          = "listaPerfil"
                      placeholder   = "Selecionar perfil"
                      options       = {listaPerfil}
                      defaultValue  = {form.perfilSelect}
                      onChange      = {onChangeSelect('perfilSelect')}
                      onClick       = {form.perfil_id = form.perfilSelect.id}
                    >
                    </ReactSelect>
                  </FormGroup>
                </Col>
              </Row>

              <Col className="ml-auto mr-auto" md="12">
                <Row>
                  {/* lista permissões */}
                  <Permissoes lista = {listaPermissao}/>
                </Row>
              </Col>
            </TabPane>
          </TabContent>

          {/* LOJAS */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="3">
              <Col className="ml-auto mr-auto" md="12">
                <Row>
                  <div className="card-2 mt-4 w-100">
                  <Col md='12'>
                    <span className="tag-card"><b>Lista das lojas</b></span>
                    {/* lista LOJAS */}
                    <ListaLojas
                      form      = {form}
                      onChange  = {onChangeArray}
                    />
                  </Col>
                  </div>
                </Row>
              </Col>
            </TabPane>
          </TabContent>

          {/* RELATÓRIOS */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="4">
              <Col className="ml-auto mr-auto" md="12">
                <Row>
                  <div className="card-2 mt-4 w-100">
                    <Col md='12' className="d-flex justify-content-center">
                      <span className="tag-card"><b>Lista dos relatórios</b></span>

                      <ListaRelatorios
                        form      = {form}
                        onChange  = {handleRelatoriosChange}
                      />

                    </Col>
                  </div>
                </Row>
              </Col>
            </TabPane>
          </TabContent>

          <Col className="text-center p-3">
            <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
            <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
          </Col>
          {validacao === "has-danger" ? (
            <FormText color="muted">
              * Campo senha/contra senha com dados incompletos
            </FormText>
          ) : null}
          </Form>
        </ModalBody>
      </FormGroup>
      </>
    )
  }
}

export default FormUsuario
